import { render, staticRenderFns } from "./allProcedureAnnex.vue?vue&type=template&id=9797ab2e&scoped=true"
import script from "./allProcedureAnnex.vue?vue&type=script&lang=js"
export * from "./allProcedureAnnex.vue?vue&type=script&lang=js"
import style0 from "./allProcedureAnnex.vue?vue&type=style&index=0&id=9797ab2e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9797ab2e",
  null
  
)

export default component.exports